import { Form, FormTextField, SearchRoundedIcon } from '@shared/components';
import debounce from 'lodash/debounce';
import { useEffect, useCallback } from 'react';
import { FormProvider, useForm } from 'react-hook-form';

import { useRoleListSearchParams } from '../../hooks';

interface RoleSearchFormInput {
  search: string;
}

export default function RoleSearchForm() {
  const [{ search }, { changeSearch }] = useRoleListSearchParams();

  const formContext = useForm<RoleSearchFormInput>({
    defaultValues: {
      search,
    },
  });

  const handleSubmit = useCallback(
    (formValues: RoleSearchFormInput) => {
      changeSearch(formValues.search);
    },
    [changeSearch],
  );

  useEffect(() => {
    const subscription = formContext.watch(debounce((formValues) => handleSubmit(formValues), 700));

    return subscription.unsubscribe;
  }, [formContext.watch, handleSubmit]);

  return (
    <FormProvider {...formContext}>
      <Form onSubmit={formContext.handleSubmit(handleSubmit)}>
        <FormTextField
          placeholder='Search for a role'
          name='search'
          slotProps={{
            input: {
              startAdornment: (
                <SearchRoundedIcon sx={{ color: (theme) => theme.palette.grey[500] }} />
              ),
            },
          }}
        />
      </Form>
    </FormProvider>
  );
}
